import React, { useState } from "react";
import { Form, Modal, notification } from "antd";
import jsonfile from "../../../../../containers/yotta/crm/customer_lead/leads.json";
import { CisUI } from "../../../../../util/CISUI";
import InputFields from "../../../../../util/InputField";
import Config from "../../../../../util/config";
import axios from "../../../../../util/Api";

const CreateCustomerModal = ({ visible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    axios
      .post(Config.apiserver + jsonfile.urls.add, values, CisUI().HeaderRequest)
      .then((res) => {
        setLoading(false);
        if (res.data.status === 1) {
          notification.success({ message: "Success", description: res.data.msg });
          form.resetFields();
          onSuccess(res.data.data);
          onClose();
        } else {
          notification.warning({ message: "Alert", description: res.data.msg });
        }
      })
      .catch(() => {
        setLoading(false);
        notification.error({ message: "Error", description: "Something went wrong" });
      });
  };

  return (
    <Modal
      title={jsonfile.addtitle}
      open={visible}
      onCancel={() => { form.resetFields(); onClose(); }}
      onOk={() => form.submit()}
      confirmLoading={loading}
      okText="Create"
      width={640}
      destroyOnClose
    >
      <style>{`.nmv-modal-form .ant-card { display: none; } .nmv-modal-form .ant-form button { display: none !important; }`}</style>
      <div className="nmv-modal-form">
        <Form
          form={form}
          {...CisUI().formItemLayout}
          name="customer_input"
          className="ant-advanced-search-form"
          onFinish={onFinish}
          initialValues={{ type: 2 }}
        >
          {InputFields(jsonfile.input, [], 0, {}, "", "")}
        </Form>
      </div>
    </Modal>
  );
};

export default CreateCustomerModal;
